import { render, staticRenderFns } from "./instagram-story-downloader.vue?vue&type=template&id=28fd7390"
import script from "./instagram-story-downloader.vue?vue&type=script&lang=js"
export * from "./instagram-story-downloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports